<script setup lang="ts">
  import { onMounted, reactive, useTemplateRef } from 'vue'
  import TurnipExchangeDropdown from './TurnipExchangeDropdown.vue'

  const props = defineProps<{
    visit: {
      userId: string
      name: string
      visitId: string
    }
  }>()

  const emit = defineEmits<{
    confirm: [userId: string, visitId: string, reportType: string, comment: string]
    cancel: []
  }>()

  const rootEl = useTemplateRef<HTMLDivElement>('rootEl')
  const state = reactive({
    shake: true,
    reportType: 'Other',
    comment: '',
  })

  const reportTypes = [
    { label: 'Inappropriate Username', value: 'Inappropriate Username' },
    { label: 'Inappropriate Behaviour', value: 'Inappropriate Behaviour' },
    { label: 'Queue System Abuse', value: 'Queue System Abuse' },
    { label: 'Other', value: 'Other' },
  ]

  onMounted(() =>
    rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }),
  )
</script>

<template>
  <div
    class="w-full max-w-2xl rounded-xl border border-red-400/80 bg-purple-500 p-8 text-white shadow-2xl"
    ref="rootEl"
    :class="{ shake: state.shake }"
    @animationend="state.shake = false"
  >
    <div class="flex h-full flex-col">
      <h2 class="font-display mb-2 text-center text-3xl font-bold">Report Visitor</h2>

      <!-- Input Section -->
      <div class="my-12 flex flex-col items-center gap-4 text-center">
        <p>Reporting the following visitor:</p>
        <p>{{ visit.name }}</p>
        <p>Reason For Report:</p>
        <TurnipExchangeDropdown
          v-model="state.reportType"
          class="w-full"
          :items="reportTypes"
          :label="state.reportType"
        >
        </TurnipExchangeDropdown>
        <textarea
          v-model="state.comment"
          class="h-24 w-full resize-none rounded-lg border-2 border-white/20 bg-white/5 p-4 text-white focus:border-green-400 focus:outline-none"
          placeholder="Tell us more about the issue..."
        ></textarea>
      </div>

      <!-- Action -->
      <div class="flex justify-center gap-4">
        <button
          @click="emit('confirm', visit.userId, visit.visitId, state.reportType, state.comment)"
          class="cursor-pointer rounded-lg bg-green-400 px-8 py-2 font-bold text-black transition-colors hover:bg-green-500"
          :disabled="!state.reportType || !state.comment"
        >
          Report
        </button>

        <button
          @click="emit('cancel')"
          class="bg-base-orange cursor-pointer rounded-lg px-8 py-2 font-bold text-black transition-colors hover:bg-red-500"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
